import { EntityConfig } from './entity-registry';
import { GenericTableColumn, GenericTableAction } from '../../../../../models/GenericCRUD/GenericTable';
import { GenericFormField } from '../../../../../models/GenericCRUD/GenericForm';
import { Filter } from '../../../../../models/GenericCRUD/Filter';

// Configuración para Tipos de IVA/Retenciones
const tableColumns: GenericTableColumn[] = [
  { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
  { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
  { name: 'Porcentaje', active: true, type: 'text', key: 'rate', sort: true },
  {
    name: 'Tipo', active: true, type: 'badge', key: 'type', sort: true,
    labelMap: { 'tax': 'IVA/Impuesto', 'retention': 'Retención' },
    colorMap: { 'tax': 'bg-blue-100 text-blue-800', 'retention': 'bg-orange-100 text-orange-800' }
  },
  {
    name: 'Por Defecto', active: true, type: 'boolean', key: 'is_default', sort: true
  },
  {
    name: 'Activo', active: true, type: 'boolean', key: 'active', sort: true
  }
];

const formFields: GenericFormField[] = [
  { name: 'name', type: 'text', label: 'Nombre', validations: 'required', colspan: 2 },
  { name: 'rate', type: 'number', label: 'Porcentaje (%)', validations: 'required', colspan: 1 },
  {
    name: 'type',
    type: 'select',
    label: 'Tipo',
    validations: 'required',
    optionsList: [
      { id: 'tax', name: 'IVA/Impuesto' },
      { id: 'retention', name: 'Retención' }
    ],
    singleSelection: true,
    colspan: 1
  },
  { name: 'description', type: 'textarea', label: 'Descripción', validations: '', colspan: 2 },
  { name: 'is_default', type: 'boolean-switch', label: 'Por Defecto (solo uno por categoría)', validations: '', colspan: 1 },
  { name: 'active', type: 'boolean-switch', label: 'Activo', validations: '', colspan: 1 }
];

const formFieldsEdit: GenericFormField[] = [
  { name: 'name', type: 'text', label: 'Nombre', validations: 'required', colspan: 2 },
  { name: 'rate', type: 'number', label: 'Porcentaje (%)', validations: 'required', colspan: 1 },
  {
    name: 'type',
    type: 'select',
    label: 'Tipo',
    validations: 'required',
    optionsList: [
      { id: 'tax', name: 'IVA/Impuesto' },
      { id: 'retention', name: 'Retención' }
    ],
    singleSelection: true,
    colspan: 1
  },
  { name: 'description', type: 'textarea', label: 'Descripción', validations: '', colspan: 2 },
  { name: 'is_default', type: 'boolean-switch', label: 'Por Defecto (solo uno por categoría)', validations: '', colspan: 1 },
  { name: 'active', type: 'boolean-switch', label: 'Activo', validations: '', colspan: 1 }
];

const tableActions: GenericTableAction[] = [
  {
    name: 'Editar',
    key: 'edit',
    form: {
      method: 'PUT',
      fields: formFieldsEdit,
      originalUpdateApiSlug: '/tax-rate/update/{{id}}',
      successTitle: 'Tipo de IVA editado correctamente',
      errorTitle: 'Error al editar tipo de IVA',
      name: 'tipo-iva',
      createButtonTitle: '',
      cols: 2,
      createApiSlug: '',
      formTitle: 'Editar Tipo de IVA/Retención',
      formButtonTitle: 'Guardar cambios',
      width: '4xl'
    },
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-black" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>',
    confirmation: false
  },
  {
    name: 'Eliminar',
    key: 'delete',
    method: 'DELETE',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
    confirmation: true,
    questionText: '¿Desea eliminar este tipo de IVA/retención?',
    deleteRowOnResponse: true,
    actionSlug: '/tax-rate/delete/{{id}}'
  }
];

const filters: Filter[] = [
  { type: 'search', key: 'name', operator: 'like', placeholder: 'Nombre' },
  {
    type: 'select',
    key: 'type',
    operator: 'in',
    placeholder: 'Tipo',
    optionsList: [
      { id: 'tax', name: 'IVA/Impuesto' },
      { id: 'retention', name: 'Retención' }
    ]
  },
  {
    type: 'select',
    key: 'is_default',
    operator: 'in',
    placeholder: 'Por Defecto',
    optionsList: [
      { id: 'true', name: 'Sí' },
      { id: 'false', name: 'No' }
    ]
  },
  {
    type: 'select',
    key: 'active',
    operator: 'in',
    placeholder: 'Estado',
    optionsList: [
      { id: 'true', name: 'Activo' },
      { id: 'false', name: 'Inactivo' }
    ]
  }
];

/**
 * Configuración completa de la entidad Tipos de IVA/Retenciones
 */
export const taxRatesConfig: EntityConfig = {
  id: 'tax-rates',
  name: 'Tipos de IVA',
  icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"/></svg>',

  tableColumns,
  formFields,
  formFieldsEdit,
  tableActions,
  filters,

  form: {
    successTitle: 'Tipo de IVA creado correctamente',
    errorTitle: 'Error al crear tipo de IVA',
    method: 'POST',
    fields: formFields,
    name: 'tipo-iva',
    createButtonTitle: 'Nuevo Tipo de IVA',
    cols: 2,
    createApiSlug: '/tax-rate/store',
    formTitle: 'Crear Tipo de IVA/Retención',
    formButtonTitle: 'Crear Tipo',
    width: '4xl'
  },

  table: {
    columns: tableColumns,
    items: [],
    type: 'generic',
    loadItemsSlug: '/tax-rate/index',
    paginate: true,
    name: 'tipos-iva',
    actions: tableActions,
    details: false
  },

  useModalForm: true
};
